export default __webpack_public_path__ + "static/crater-972dd5badaf9d47b6b33d5b75693f638.jpg";